var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollarB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 309,
    viewBox: "0 0 248 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19,164.5) scale(1.1,1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Collar",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.996 32.873C92.5344 22.6589 85.768 16.1543 76.1023 4.00001C75.7718 4.03608 75.5217 4.06723 75.3607 4.09231C73.3243 4.40945 69.2031 5.02563 67.7607 5.44982C79.8527 20.4267 89.1353 29.2953 106.996 41.6389C124.857 29.2953 134.139 20.4267 146.231 5.44982C144.789 5.02563 140.668 4.40945 138.632 4.09231C138.47 4.06722 138.22 4.03607 137.89 4C128.224 16.1543 121.457 22.6589 106.996 32.873Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5,168) scale(0.8,0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.996 32.873C92.5344 22.6589 85.768 16.1543 76.1023 4.00001C75.7718 4.03608 75.5217 4.06723 75.3607 4.09231C73.3243 4.40945 69.2031 5.02563 67.7607 5.44982C79.8527 20.4267 89.1353 29.2953 106.996 41.6389C124.857 29.2953 134.139 20.4267 146.231 5.44982C144.789 5.02563 140.668 4.40945 138.632 4.09231C138.47 4.06722 138.22 4.03607 137.89 4C128.224 16.1543 121.457 22.6589 106.996 32.873Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollarB);
export default __webpack_public_path__ + "static/media/Collar B.9f14107f8c95e0d778574831c7c1af69.svg";
export { ForwardRef as ReactComponent };